import styled from 'styled-components'
import { colors, Button } from '@giphy/react-giphy-brand'

const Apple = styled(Button)`
    background: ${colors.giphyDarkGrey};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ButtonText = styled.div`
    padding-left: 10px;
`

const AppleButton = ({ className, onClick, label }) => (
    <Apple className={className} onClick={onClick} type="button">
        <ButtonText>{label}</ButtonText>
    </Apple>
)

export default AppleButton
